<template>
  <header class="app-header navbar">
    <slot></slot>
  </header>
</template>
<script>
export default {
  name: 'navbar',
  created () {
  }
}
</script>



// WEBPACK FOOTER //
// src/components/header/Navbar.vue